import CardDzikirRead from './CardDzikirRead';

export default CardDzikirRead;
